import React from 'react';
import { Link } from 'gatsby';
import { Box } from '@theme-ui/components';
import FooterSection from '../03_organisms/FooterSection/FooterSection';
import GenericSection from '../03_organisms/GenericSection/GenericSection';
import Section from '../02_molecules/Section/Section';
import Layout from '../../global/Layout';
import Seo from '../../global/Seo';
import Logo from '../01_atoms/Logo/Logo';

export interface MDXPageProps {
  children: React.ReactNode;
  pageContext?: any;
  linkPrefix?: string;
}
const MDXPage: React.FC<MDXPageProps> = ({
  children,
  pageContext,
  linkPrefix,
}: MDXPageProps) => {
  const title = pageContext?.frontmatter?.title ?? '';

  return (
    <Layout>
      <Seo title={title} />
      <Box>
        <Section py={8}>
          <Link to={`${linkPrefix || ''}/`}>
            <Logo
              sx={{
                maxHeight: '7rem',
              }}
            />
          </Link>
        </Section>
        <GenericSection title={title}>
          <Box>{children}</Box>
        </GenericSection>
      </Box>
    </Layout>
  );
};

export default MDXPage;
